// extracted by mini-css-extract-plugin
module.exports = {"container":"relevancyvote_container__RtE_z","form":"relevancyvote_form__ovXeP","submit":"relevancyvote_submit__2ghVj"};